module.exports = __webpack_public_path__ + "static/media/delete.8a2fe490.svg";